import React from 'react'
import { Input, Form, Col, Select } from 'antd'

import './index.css'

const { Option } = Select

const MarketPlaceTopSection = ({ props, onChangeAuthor }) => {
  const {
    t,
    form: { getFieldDecorator },
    courseBuilder: { courseOrganiser, courseId }
  } = props
  return (
    <div className="mp-top_section_row">
      <Col md={7}>
        <Form.Item colon={false} required={false} label={t('labels:course id')}>
          {getFieldDecorator('course_id', {
            initialValue: courseId
          })(<Input size="large" maxLength={100} type="number" disabled />)}
        </Form.Item>
      </Col>

      <Col md={7}>
        <Form.Item label={t('labels:status')} colon={false} required={false}>
          {/* {getFieldDecorator('status', {
            initialValue: 'pending'
          })( */}
          <Select showSearch size="large" disabled value="pending">
            <Option value="pending">{t('v3:pending')}</Option>
            <Option value="published">{t('v3:published')}</Option>
          </Select>
          {/* )} */}
        </Form.Item>
      </Col>

      <Col md={7}>
        <Form.Item label={t('labels:author')} colon={false} required={false}>
          {getFieldDecorator('organiser', {
            rules: [{ required: true, message: t('v4:author_name') }],
            initialValue: courseOrganiser
          })(
            <Input
              addonBefore={t('general:by')}
              size="large"
              maxLength={100}
              placeholder={t('placeholders:organiser')}
              onChange={e => onChangeAuthor(e.target.value)}
            />
          )}
        </Form.Item>
      </Col>
    </div>
  )
}

export { MarketPlaceTopSection }
